export enum TrustGroupType {
    Unknown = "Unknown",
    Supplier = "Supplier",
    Channel2Customer = "Channel2Customer",
    Channel1Customer = "Channel1Customer"
}
